import React from "react";
import { Link } from "react-router-dom";
import Accordion from "./Accordion";
import { FaArrowRight } from "react-icons/fa";
import AdBanner from "../../components/AdBanner";

const Home = () => {
  return (
    <main>
      <div className="section1 lg:my-[80px] relative h-auto rounded-b-2xl">
        <div className="containerMain grid grid-cols-1 xl:grid-cols-2 gap-10 justify-between items-center mx-auto place-items-center pt-[70px] pb-[120px] xl:py-[50px] ">
          <div className="leftArea w-full flex flex-col justify-center gap-8 relative">
            <div className="title">
              <h1 className="text-5xl sm:text-6xl leading-[58px] font-bold text-dark sm:pl-8 text-center sm:text-left">
                Adım Adım Kariyer Yolculuğunu{" "}
                <span className="text-darkerGreen whitespace-nowrap">
                  Başlat!
                </span>
              </h1>
            </div>
            <p className="p-light-style text-center sm:text-left sm:pl-8">
              Junior olarak kariyerine sağlam bir adım atmak isteyenler için
              harika bir fırsat! Burada, yeteneklerini geliştirebilir,
              profesyonel projelerde deneyim kazanabilir ve gerçek dünyada
              uygulamalı öğrenme fırsatları yakalayabilirsin.
            </p>
            <Link
              to="./kayit_ol"
              className="btn-green max-w-[180px] mx-auto sm:ml-8"
            >
              <p className="flex justify-between items-center gap-2">
                Hemen Kayıt Ol{" "}
                <span>
                  <FaArrowRight />
                </span>
              </p>
            </Link>
            <div className="absolute hidden lg:block left-0 sm:left-[-20px] top-[-50px]">
              <img src="/İconShape.svg" alt="Icon Shape" />
            </div>
          </div>

          <div className="rightArea w-full flex items-center justify-center">
            <img
              src="/MaskeliFotoğraf.svg"
              alt="Masked Photo"
              className="w-[300px] sm:w-[500px] xl:w-[520px] xl:h-[632px]"
            />
          </div>
        </div>
        <div className="absolute hidden xl:block xl:bottom-[-20px] left-0 ">
          <img src="/Kare.svg" alt="Square Shape" />
        </div>
        {/* <div className="absolute top-[-20px] right-[120px] z-[-1]">
          <img src="/TopRightShapes.svg" alt="Top Right Shapes" />
        </div> */}
      </div>
      <div className="section2 bg-dark bg-[url('/Blob.svg')] bg-cover bg-center py-[70px] h-auto mt-[-60px] rounded-b-2xl">
        <div className="container">
          <div className="title">
            <h2 className="text-center text-4xl leading-[58px] font-bold text-white sm:text-left">
              Gerçekleşecek bir projede
              <br />
              <span className="text-darkerGreen whitespace-nowrap">
                başlangıcını yap!
              </span>
            </h2>
          </div>
          <div className="inner grid grid-cols-1 xl:grid-cols-2 justify-between gap-8 items-center mx-auto">
            <div className="leftArea p-12 flex flex-col gap-10">
              <div className="row flex flex-col gap-8 sm:flex-row justify-between items-center px-10">
                <div className="max-w-50 flex flex-col justify-center items-center gap-2">
                  <img src="/sec2icon1.svg" alt="Section 2 Icon 1" />
                  <p className="text-base text-white text-center">
                    Yetkinliklerini seç ve
                    <br /> profilini oluştur!
                  </p>
                </div>
                <div className="hidden sm:block">
                  <img src="/RightArrow.svg" alt="Right Arrow" />
                </div>
                <div className="max-w-50 flex flex-col justify-center items-center gap-2">
                  <img src="/sec2icon2.svg" alt="Section 2 Icon 2" />
                  <p className="text-base text-white text-center">
                    Projeni geliştir ve
                    <br /> deneyim kazan!
                  </p>
                </div>
              </div>
              <div className="sm:row sm:flex sm:justify-end sm:px-28 hidden">
                <img src="/Arrow.svg" alt="Arrow" />
              </div>
              <div className="row flex flex-col gap-8 sm:flex-row justify-between items-center px-8">
                <div className="max-w-50 flex flex-col justify-center items-center gap-2">
                  <img src="/sec2icon4.svg" alt="Section 2 Icon 4" />
                  <p className="text-base text-white text-center">
                    Projeni paylaş ve
                    <br /> iş teklifleri al!
                  </p>
                </div>
                <div className="hidden sm:block">
                  <img src="/LeftArrow.svg" alt="Left Arrow" />
                </div>
                <div className="max-w-50 flex flex-col justify-center items-center gap-2">
                  <img src="/sec2icon3.svg" alt="Section 2 Icon 3" />
                  <p className="text-base text-white text-center">
                    Mentörlük al ve
                    <br /> gelişmeye devam et!
                  </p>
                </div>
              </div>
            </div>

            <div className="rightArea m-10 flex flex-col gap-8 relative">
              <div className="absolute right-[-25px] sm:right-[-65px] top-[-60px] hidden lg:block">
                <img src="/cornerShape2.svg" alt="Corner Shape 2" />
              </div>
              <p className="p-dark-style text-center sm:text-left">
                Juniors platformu, yeteneklerini geliştirebileceğin ve gerçek
                dünya projelerinde deneyim kazanabileceğin bir fırsat sunuyor.
                Her hafta yayınlanan projelere katılarak, seni destekleyecek
                deneyimli profesyonellerle çalışabilir, mentörlük alarak hızla
                gelişebilirsin. Ayrıca projelerde elde ettiğin başarılarla
                portföyünü güçlendirip, sektördeki kariyerin için sağlam adımlar
                atabilirsin. Sen de geleceğini inşa etmek için bu fırsatı
                değerlendirebilir, yaratıcı projelerde yer alarak yeteneklerini
                sergileyebilirsin!
              </p>
              <Link
                to="/projeler"
                className="btn-green max-w-[180px] text-center mx-auto sm:mx-0"
              >
                Projeleri Görüntüle
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="section3 py-[70px] h-auto relative rounded-b-2xl">
        <div className="container flex flex-col gap-8">
          <div className="title">
            <h3 className="text-4xl leading-[58px] font-bold text-dark text-center">
              Geleceğin yıldızlarını yetiştir!
            </h3>
          </div>
          <p className="text-center text-grayy">
            Juniors platformunda deneyimlerinle yeni yeteneklerin gelişimine yön
            verebilir, rehberlik ederek geleceğin yıldızlarına
            dönüştürebilirsin. Sosyal sorumluluğunu yerine getirirken mentörlük
            yaparak hem kendi portföyüne katkı sağlar hem de sektöre değer
            katarsın. Gel, deneyimlerinle fark yarat ve yeni yeteneklere ilham
            ol!
          </p>
          <ul className="flex flex-wrap md:flex-wrap lg:flex-nowrap justify-center lg:justify-between items-center gap-8 lg:gap-6 md:mx-6">
            <li className="w-[45%] sm:w-[30%] lg:w-auto flex flex-col justify-center items-center gap-2">
              <span>
                <img src="/sec3icon1.svg" alt="Section 3 Icon 1" />
              </span>
              <p className="text-base text-grayy text-center">
                Profilini oluştur,
                <br /> yetkinliklerini seç ve
                <br /> uygun Junior'larla eşleş.
              </p>
            </li>
            <li className="hidden lg:block">
              <img src="/cizgi.svg" alt="Line" />
            </li>
            <li className="w-[45%] sm:w-[30%] lg:w-auto flex flex-col justify-center items-center gap-2">
              <span>
                <img src="/sec3icon2.svg" alt="Section 3 Icon 2" />
              </span>
              <p className="text-base text-grayy text-center">
                Eşleştiğin Junior'lara
                <br /> haftada bir saat mentörlük
                <br /> oturumu planla.
              </p>
            </li>
            <li className="hidden lg:block">
              <img src="/cizgi.svg" alt="Line" />
            </li>
            <li className="w-[45%] sm:w-[30%] lg:w-auto flex flex-col justify-center items-center gap-2">
              <span>
                <img src="/sec3icon3.svg" alt="Section 3 Icon 3" />
              </span>
              <p className="text-base text-grayy text-center">
                Haftalık Junior değerlendirmelerine
                <br /> katılarak süreci takip et
                <br />
                ve geri bildirim ver.
              </p>
            </li>
            <li className="hidden lg:block">
              <img src="/cizgi.svg" alt="Line" />
            </li>
            <li className="w-[45%] sm:w-[30%] lg:w-auto flex flex-col justify-center items-center gap-2">
              <span>
                <img src="/sec3icon4.svg" alt="Section 3 Icon 4" />
              </span>
              <p className="text-base text-grayy text-center">
                Geleceğin senior'larını
                <br /> yetiştirerek sosyal sorumluluğunu
                <br />
                yerine getir.
              </p>
            </li>
          </ul>
        </div>
        <div className="absolute left-0 bottom-[150px] hidden lg:block">
          <img src="/RectangleBlack.svg" alt="Rectangle Black" />
        </div>
        <div className="absolute right-0 bottom-[150px] hidden lg:block">
          <img src="/RectangleGrn.svg" alt="Rectangle Green" />
        </div>
      </div>
      <AdBanner /> {/* Reklam burada görünecek */}
      <Accordion page="home" />
      <div className="container section5 py-[120px] h-auto flex flex-col gap-12 items-center rounded-b-2xl">
        <div className="title flex justify-center items-center gap-4">
          <img src="/sec5.svg" alt="Section 5" />
          <h1 className="text-4xl leading-[58px] font-bold text-dark text-center">
            Sen de gerçekleşecek projelerde
            <span className="text-darkerGreen"> yerini al!</span>
          </h1>
        </div>
        <Link to="/projeler" className="btn-dark max-w-[200px] text-center">
          Hemen Ekibe Katıl!
        </Link>
      </div>
    </main>
  );
};

export default Home;
